/* egressErrorMessage.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./egressErrorMessage.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React, { lazy, useContext } from 'react';
import { RendererContext } from '../../context';
import MediaServicesNoImageIcon from '@atlaskit/icon/glyph/media-services/no-image';
import ErrorIcon from '@atlaskit/icon/core/migration/error';
import ShortcutIcon from '@atlaskit/icon/core/migration/link-external--shortcut';
import { Text, Box } from '@atlaskit/primitives';
var AKButton = /*#__PURE__*/lazy(function () {
  return import( /* webpackChunkName: '@atlaskit-internal_.button' */
  '@atlaskit/button');
});
var LinkWithIcon = function LinkWithIcon(_ref) {
  var href = _ref.href,
    text = _ref.text;
  return /*#__PURE__*/React.createElement(AKButton, {
    iconAfter: /*#__PURE__*/React.createElement(ShortcutIcon, {
      color: "currentColor",
      label: ""
    }),
    appearance: "link",
    href: href,
    target: "_blank",
    spacing: "none"
  }, text);
};
export var EgressErrorMessage = function EgressErrorMessage(_ref2) {
  var url = _ref2.url;
  var _useContext = useContext(RendererContext),
    forgeEnvironment = _useContext.forgeEnvironment;
  var dataUriRegex = /^data/;
  var isDataUri = dataUriRegex.test(url);
  if (forgeEnvironment === 'DEVELOPMENT') {
    return /*#__PURE__*/React.createElement("div", {
      "data-testid": "egress-error-message",
      className: ax(["_1e0c1txw _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp"])
    }, /*#__PURE__*/React.createElement("div", {
      className: ax(["_1wpz1h6o"])
    }, /*#__PURE__*/React.createElement(MediaServicesNoImageIcon, {
      label: "",
      size: "large"
    })), /*#__PURE__*/React.createElement("div", {
      className: ax(["_1reo15vq _18m915vq _1e0c1txw _19bvutpp _syazpbcx"])
    }, /*#__PURE__*/React.createElement(ErrorIcon, {
      color: "currentColor",
      spacing: "spacious",
      label: ""
    }), /*#__PURE__*/React.createElement(Box, {
      paddingInlineStart: "space.050"
    }, /*#__PURE__*/React.createElement(Text, {
      as: "p",
      color: "color.text.danger"
    }, isDataUri ? /*#__PURE__*/React.createElement(React.Fragment, null, "Please use the ", /*#__PURE__*/React.createElement("b", null, "data:image"), " scheme for an image source.") : /*#__PURE__*/React.createElement(React.Fragment, null, "Egress permissions for ", /*#__PURE__*/React.createElement(LinkWithIcon, {
      href: url,
      text: url
    }), " missing in the manifest. For more information", ' ', /*#__PURE__*/React.createElement(LinkWithIcon, {
      href: "https://developer.atlassian.com/platform/forge/manifest-reference/permissions/#images",
      text: "see reference docs"
    }), ".")))));
  }
  return /*#__PURE__*/React.createElement("div", {
    title: "Unable to display due to an image link issue."
  }, /*#__PURE__*/React.createElement(MediaServicesNoImageIcon, {
    label: ""
  }));
};